import { theme as baseTheme, removePixelValues, } from "@clearabee/ui-library-base";
import deepClone from "deep-clone";
const updatedTheme = deepClone(baseTheme);
removePixelValues(updatedTheme);
export const theme = updatedTheme;
//# sourceMappingURL=theme.js.map